import { TableData } from '@models/table-data';

// table data for  Handyversicherung landing page
export const handyBenefitsTable: TableData = {
    subtitles: ['', 'Das leistet unsere Versicherung', 'Leistungsbegrenzungen'],
    collapsedTitle: 'Das leistet die astra Handyversicherung ',
    rows: [
        {
            title: 'Versicherte Geräte',
            cells: [
                { type: 'text', value: 'Alle Smartphones' },
                { type: 'text', value: 'Gerätealter bis zu 6&nbsp;Monate' },
            ],
        },
        {
            title: 'Laufzeit',
            cells: [
                { type: 'text', value: 'Keine Mindestlaufzeit' },
                { type: 'check', checkmark: false, value: 'keine', iconColor: 'green' },
            ],
        },
        {
            title: 'Kündigung',
            cells: [
                { type: 'text', value: 'Tägliche Kündigungsfrist' },
                { type: 'check', checkmark: false, value: 'keine', iconColor: 'green' },
            ],
        },
        {
            title: 'Totalschaden',
            cells: [
                { type: 'text', value: 'Gleichwertiger Ersatz im ersten Jahr' },
                {
                    type: 'text',
                    value: '2.&nbsp;Jahr: 85&nbsp;%<br>3.&nbsp;Jahr: 70&nbsp;%<br>4.&nbsp;Jahr: 45&nbsp;%',
                },
            ],
        },
        {
            title: 'Sofortschutz',
            cells: [
                { type: 'text', value: 'Bei Abschluss innerhalb von 6&nbsp;Wochen nach Kauf' },
                { type: 'text', value: 'Bei Abschluss später als 6&nbsp;Wochen nach Kauf' },
            ],
        },
        {
            title: 'Diebstahlschutz',
            cells: [
                { type: 'text', value: 'Optional' },
                { type: 'text', value: 'Ortungsfunktion muss aktiviert sein, nicht bei Fahrlässigkeit' },
            ],
        },
        {
            title: 'Geltungsbereich',
            cells: [
                { type: 'text', value: 'Weltweit' },
                { type: 'check', checkmark: false, value: 'keine', iconColor: 'green' },
            ],
        },
    ],
    highlighted: 0,
};
